import { Fragment } from 'react';

import type { TextSpan } from './types';

export interface SpanRendererProp {
  text: string;
  spans?: TextSpan[];
}

export function SpanRenderer({ text, spans }: SpanRendererProp) {
  if (!(Array.isArray(spans) && spans.length > 0)) {
    return <>{text}</>;
  }

  return (
    <>
      {spans.map((span, index, allSpans) => {
        const lastSpan = allSpans[index - 1];
        const lastEnd = lastSpan ? lastSpan.end : 0;

        const nextSpan = allSpans[index + 1];
        const nextStart = nextSpan ? nextSpan.start : text.length;

        const HTMLElement = span.type;

        return (
          <Fragment key={index}>
            {text.slice(lastEnd, span.start)}
            <HTMLElement key={index}>
              {text.slice(span.start, span.end)}
            </HTMLElement>
            {text.slice(span.end, nextStart)}
          </Fragment>
        );
      })}
    </>
  );
}
